import { FormControlLabel, Switch } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import {} from '../../../../../fetch';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface IStandardFeaturesStandaloneFeature {
  handleChange: (value: number) => void;
  name: string;
  id: number;
  isLoading: boolean;
  selected: number[];
}
export const StandardFeaturesStandaloneFeature: FC<IStandardFeaturesStandaloneFeature> = ({
  handleChange,
  name,
  id,
  isLoading,
  selected
}) => {
  const [value, setValue] = useState<boolean>(selected?.includes(id));

  useEffect(() => {
    setValue(selected?.includes(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const classes = useStyles();
  return (
    <div className={classes.switch} key={name}>
      <FormControlLabel
        control={
          <Switch
            disabled={isLoading}
            color="primary"
            checked={value}
            id="option"
            onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
              handleChange(id);
            }}
          />
        }
        label={`${name}`}
      />
    </div>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  switch: {
    margin: theme.spacing(1)
  }
}));
